import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'red-cross-button-circle',
    templateUrl: './red-cross-button-circle.component.html',
    styleUrls: ['./red-cross-button-circle.component.css'],
    standalone: false
})
export class RedCrossButtonCircleComponent implements OnInit {

  @Output() press = new EventEmitter();
    
  constructor() {}

  onPress() {
    this.press.emit();
  }

  ngOnInit() {}

}
